import { Chip } from '~/shared/ui'
import { CONFIDENCE_SCORE_THRESHOLD } from '../../config'

export function ClassificationChip({
  confidenceScore,
  displayLabel,
  isSelected,
}: {
  confidenceScore: number
  displayLabel: string
  isSelected: boolean
}) {
  return (
    <Chip
      size="sm"
      rounded
      info={isSelected && confidenceScore >= CONFIDENCE_SCORE_THRESHOLD}
      warning={isSelected && confidenceScore < CONFIDENCE_SCORE_THRESHOLD}
      outlined={!isSelected}
      disabled={!isSelected}
    >
      {displayLabel}
    </Chip>
  )
}
